import React, { useState } from 'react';
import { signInWithPopup, GoogleAuthProvider } from 'firebase/auth';
import { Button, Container, Typography, Box, Alert } from '@mui/material';
import { auth } from '../firebase/config';
import { useAuth } from '../firebase/hooks/useAuth';
import { checkAllowedUser } from '../firebase/utils/allowedUsers';

export const Auth: React.FC = () => {
  const { loading } = useAuth();
  const [error, setError] = useState<string | null>(null);

  const signInWithGoogle = async () => {
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      const email = result.user.email;
      
      if (!email) {
        throw new Error('No email found');
      }

      const isAllowed = await checkAllowedUser(email);
      
      if (!isAllowed) {
        // Sign out the user if they're not allowed
        await auth.signOut();
        setError('You are not authorized to access this application. Please contact the administrator.');
        return;
      }

      setError(null);
    } catch (error) {
      console.error('Auth error:', error);
      setError('Authentication failed. Please try again.');
    }
  };

  if (loading) {
    return (
      <Container maxWidth="sm">
        <Box sx={{ 
          marginTop: 8, 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center' 
        }}>
          <Typography>Loading...</Typography>
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="sm">
      <Box sx={{ 
        marginTop: 8, 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center' 
      }}>
        <Typography component="h1" variant="h5" sx={{ mb: 3 }}>
          Product Roadmap
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 3, width: '100%' }}>
            {error}
          </Alert>
        )}

        <Button
          variant="contained"
          onClick={signInWithGoogle}
          sx={{ mt: 3, mb: 2 }}
        >
          Sign in with Google
        </Button>
      </Box>
    </Container>
  );
};